import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import Search from '@/assets/icons/search_line.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { isMacPlatform } from '@/utils/platform';

import styles from './QuickSearchTrigger.module.scss';

export interface QuickSearchTriggerProps {
    onClick: () => void;
    variant?: 'header' | 'mobile';
}

export default function QuickSearchTrigger(props: QuickSearchTriggerProps) {
    const { onClick, variant = 'header' } = props;
    const { t } = useTranslation();
    const isMac = isMacPlatform();
    const shortcutLabel = isMac ? '⌘K' : 'Ctrl+K';

    return (
        <button
            type="button"
            className={cn(styles.button, {
                [styles.header]: variant === 'header',
                [styles.mobile]: variant === 'mobile',
            })}
            onClick={onClick}
            // Named by its visible label, not an aria-label: a spoken name that differs from
            // the words on screen is one a voice-control user cannot say to press it. The
            // shortcut chip is hidden from the name and announced through aria-keyshortcuts.
            aria-keyshortcuts="Meta+K Control+K">
            <SvgIcon
                icon={Search}
                size="inherit"
                className={styles.icon}
                svgProps={{ 'aria-hidden': true }}
            />
            <span className={styles.label}>{t('quickSearch.trigger.label', 'Quick search')}</span>
            {variant === 'header' && (
                <kbd className={styles.kbd} aria-hidden="true">
                    {shortcutLabel}
                </kbd>
            )}
        </button>
    );
}
